import util from '../util'

let controller = 'v1/ConfiguracaoAntifraude'

export default Object.assign({}, util.GetCrud(controller, null), {
  ListarConfiguracaoAntifraudePaginado: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + "/ListarConfiguracaoAntifraudePaginado", dto)
  },
  SalvarConfiguracao: function (dto) {
    return util.Axios.Post(controller + '/SalvarConfiguracao', dto)
  }
})